export default __webpack_public_path__ + "static/media/45_photo.788c0110.jpg";